const cursor = document.querySelector('.cursor');

let isInitialized = false;
let xTo = null;
let yTo = null;
let onMouseOver = null;
let onMouseOut = null;
let onMouseMove = null;

const isTouchDevice = () => (
    ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0)
);

const coarseMedia = window.matchMedia ? window.matchMedia('(pointer: coarse)') : null;

function shouldEnableCursor() {
    const isCoarse = coarseMedia ? coarseMedia.matches : false;
    return !isCoarse && !isTouchDevice();
}

function initCustomCursor() {
    if (isInitialized || !cursor) return;

    // Ensure it's visible if previously hidden
    cursor.style.removeProperty('display');

    onMouseOver = (e) => {
        cursor.classList.remove('cursor-on-link', 'cursor-on-text');
        const linkLike = e.target.closest('a, button, input, [role="button"], .button, .btn');
        if (linkLike) {
            cursor.classList.add('cursor-on-link');
        } else if (e.target.closest('p, h1, h2, h3, h4, h5, h6')) {
            cursor.classList.add('cursor-on-text');
        }
    };

    onMouseOut = (e) => {
        const toElement = e.relatedTarget;
        if (!toElement) {
            cursor.classList.remove('cursor-on-link', 'cursor-on-text');
            return;
        }
        const linkLike = toElement.closest('a, button, input, [role="button"], .button, .btn');
        if (linkLike) {
            cursor.classList.add('cursor-on-link');
            cursor.classList.remove('cursor-on-text');
            return;
        }
        const textLike = toElement.closest('p, h1, h2, h3, h4, h5, h6');
        if (textLike) {
            cursor.classList.add('cursor-on-text');
            cursor.classList.remove('cursor-on-link');
            return;
        }
        cursor.classList.remove('cursor-on-link', 'cursor-on-text');
    };

    document.addEventListener('mouseover', onMouseOver);
    document.addEventListener('mouseout', onMouseOut);

    if (window.gsap) {
        gsap.set(cursor, { xPercent: -50, yPercent: -50 });
        xTo = gsap.quickTo(cursor, 'x', { duration: 0.6, ease: 'power3' });
        yTo = gsap.quickTo(cursor, 'y', { duration: 0.6, ease: 'power3' });
    }

    onMouseMove = (e) => {
        if (xTo && yTo) {
            xTo(e.clientX);
            yTo(e.clientY);
        }
    };
    window.addEventListener('mousemove', onMouseMove);

    isInitialized = true;
}

function destroyCustomCursor() {
    if (!cursor) return;

    if (onMouseOver) document.removeEventListener('mouseover', onMouseOver);
    if (onMouseOut) document.removeEventListener('mouseout', onMouseOut);
    if (onMouseMove) window.removeEventListener('mousemove', onMouseMove);

    if (window.gsap) {
        gsap.killTweensOf(cursor);
    }

    cursor.classList.remove('cursor-on-link', 'cursor-on-text');
    cursor.style.display = 'none';

    onMouseOver = null;
    onMouseOut = null;
    onMouseMove = null;
    xTo = null;
    yTo = null;
    isInitialized = false;
}

function handleResponsiveChange() {
    if (shouldEnableCursor()) {
        initCustomCursor();
    } else {
        destroyCustomCursor();
    }
}

function debounce(fn, delay) {
    let t;
    return function () {
        const ctx = this, args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
}

if (cursor) {
    // Initial decide
    handleResponsiveChange();

    // Listen for pointer capability changes (e.g., attaching a mouse to a tablet)
    if (coarseMedia) {
        if (typeof coarseMedia.addEventListener === 'function') {
            coarseMedia.addEventListener('change', handleResponsiveChange);
        } else if ('onchange' in coarseMedia) {
            coarseMedia.onchange = handleResponsiveChange;
        }
    }

    // Fallback: also react on resize to handle desktop->mobile breakpoints
    window.addEventListener('resize', debounce(handleResponsiveChange, 150));
}